export default __webpack_public_path__ + "static/media/Nitrox2011.dfe517cd.png";